// src/services/vpnService.js
/**
 * Servicio Adaptador del Frontend para Detección de VPN/Proxy.
 * Realiza la consulta ÚNICAMENTE hacia el backend (/api/security/check-ip),
 * trasladando la detección de IP, consultas a proveedores e inteligencia de riesgo al servidor.
 * 
 * Mantiene 100% de compatibilidad con todas las firmas de exportación existentes.
 */

/**
 * Consulta el endpoint backend de seguridad /api/security/check-ip.
 * 
 * @returns {Promise<{
 *   allowed: boolean,
 *   ip: string,
 *   isVpn: boolean,
 *   isProxy: boolean,
 *   isHosting: boolean,
 *   isTor: boolean,
 *   vpnRiskScore: number,
 *   riskLevel: string,
 *   reasons: string[],
 *   isp: string,
 *   org: string,
 *   country: string,
 *   countryCode: string,
 *   city: string,
 *   asn: string,
 *   timezone: string,
 *   provider: string
 * }>}
 */
export const checkIpVpnStatus = async () => {
    try {
        const timestamp = Date.now();
        // Intentar endpoint relativo del servidor actual
        let backendUrl = `https://backend.eldenguee.com/security/check-ip?t=${timestamp}`;

        let res;
        try {
            res = await fetch(backendUrl, {
                cache: 'no-store',
                headers: { 'Cache-Control': 'no-cache, no-store, must-revalidate' }
            });
        } catch (_) { }

        if (!res || !res.ok) {
            try {
                res = await fetch(`/api/security/check-ip?t=${timestamp}`, { cache: 'no-store' });
            } catch (_) { }
        }


        if (res && res.ok) {
            const data = await res.json();
            console.log('🛡️ [Backend Security Check Output]:', data);
            return {
                allowed: data.allowed !== false,
                ip: data.ip || '',
                isVpn: !!data.isVpn,
                isProxy: !!data.isProxy,
                isHosting: !!data.isHosting,
                isTor: !!data.isTor,
                vpnRiskScore: typeof data.vpnRiskScore === 'number' ? data.vpnRiskScore : 0,
                riskLevel: data.riskLevel || 'low',
                reasons: Array.isArray(data.reasons) ? data.reasons : [],
                isp: data.isp || '',
                org: data.org || '',
                country: data.country || '',
                countryCode: data.countryCode || '',
                city: data.city || '',
                asn: data.asn || '',
                timezone: data.timezone || '',
                provider: data.provider || 'backend'
            };
        }
    } catch (err) {
        console.error('❌ Error al consultar backend de seguridad:', err);
    }

    // Fallback seguro si no hay conexión al backend
    return {
        allowed: true,
        ip: '',
        isVpn: false,
        isProxy: false,
        isHosting: false,
        isTor: false,
        vpnRiskScore: 0,
        riskLevel: 'low',
        reasons: ['Backend temporalmente no disponible, fallback activo'],
        isp: '',
        org: '',
        country: '',
        countryCode: '',
        city: '',
        asn: '',
        timezone: '',
        provider: 'client_fallback'
    };
};
